/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAwsSsmDocuments extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAwsSsmDocuments");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAwsSsmDocuments.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAwsSsmDocuments>): BackgroundJobPayloadForPeriodicAwsSsmDocuments {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAwsSsmDocuments(), model);
        BackgroundJobPayloadForPeriodicAwsSsmDocuments.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAwsSsmDocuments>): BackgroundJobPayloadForPeriodicAwsSsmDocuments {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAwsSsmDocuments.newInstance(<BackgroundJobPayloadForPeriodicAwsSsmDocuments> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAwsSsmDocuments) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAwsSsmDocuments.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAwsSsmDocuments): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAwsSsmDocuments.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
